function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { PancakeStack, PancakeInput, PancakeLabel } from "./StyledPancakeToggle";
import { scales } from "./types";
var PancakeToggle = function(_param) /*#__PURE__*/ {
    var checked = _param.checked, _scale = _param.scale, scale = _scale === void 0 ? scales.LG : _scale, props = _objectWithoutProperties(_param, [
        "checked",
        "scale"
    ]);
    return _jsxs(PancakeStack, {
        scale: scale,
        children: [
            /*#__PURE__*/ _jsx(PancakeInput, _objectSpread({
                id: props.id || "pancake-toggle",
                scale: scale,
                type: "checkbox",
                checked: checked
            }, props)),
            /*#__PURE__*/ _jsx(PancakeLabel, {
                scale: scale,
                checked: checked,
                htmlFor: props.id || "pancake-toggle",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "pancakes",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "pancake"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "pancake"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "pancake"
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "butter"
                        })
                    ]
                })
            })
        ]
    });
};
export default PancakeToggle;
